import { Button, MenuItem, Select, Stack } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import Modal, { CommonModalProps } from "..";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { ingestService } from "../../../Core/Api/services";
import useCustomSnackbar from "../../../Utils/Hooks/useCustomSnackbar";
import { DbIngestConfigPackInfos } from "../../../Core/Api/Types/db-ingest-config-pack-infos";
import { useTranslation } from "react-i18next";

type CloseClbProps = {
  confirm: boolean;
};

export type ModalMoveIngestPackElementProps = {
  onClose?: (props: CloseClbProps) => void;
  onConfirm?: () => void;
  placeholderIds: number[];
};
export type ModalMoveIngestPackProps = CommonModalProps<ModalMoveIngestPackElementProps>;

const ModalMoveIngestPack = React.forwardRef<any, ModalMoveIngestPackProps>((props, ref) => {
  const { closeModal, onClose, onConfirm, placeholderIds, ...modalProps } = props;
  const [packs, setPacks] = useState<DbIngestConfigPackInfos[]>([]);
  const [packId, setPackId] = useState<number>(-1);
  const enqueueSnackbar = useCustomSnackbar();
  const { t } = useTranslation();

  const handleCancelClick = () => {
    onClose && onClose({ confirm: false });
    closeModal();
  };

  const handleConfirmClick = useCallback(() => {
    if (!packId) return;

    ingestService.MovePlaceholders({ placeholderIds: placeholderIds, packId: packId }).then(function (response) {
      if (response.success) {
        onConfirm && onConfirm();
        enqueueSnackbar(t("alert:success.placeholdersMoved"), "success");
      } else enqueueSnackbar(t("alert:error.movingPlaceholders", { message: response.message }), "warning");
    });
  }, [packId]);

  useEffect(() => {
    ingestService.GetConfigPackList().then(function (response) {
      if (response.packs) setPacks(response.packs);
    });
  }, []);

  return (
    <Modal
      {...modalProps}
      title={t("modal:title.movePlaceholders")}
      reference={ref}
      closeModal={handleCancelClick}
      width={504}
      footer={
        <Stack direction="row" justifyContent="space-between">
          <Button onClick={handleCancelClick}>{t("common:cancel")}</Button>
          <Button variant="contained" color="primary" onClick={handleConfirmClick} disabled={packId === -1}>
            {t("common:move")}
          </Button>
        </Stack>
      }
    >
      <Select
        displayEmpty
        IconComponent={ExpandMoreRoundedIcon}
        MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
        value={packId}
        onChange={(e) => setPackId(e.target.value as number)}
      >
        <MenuItem value={-1} key="empty">
          {t("field:placeholder.selectDestinationPack")}
        </MenuItem>
        {packs.map((pack) => (
          <MenuItem value={pack.id} key={pack.id}>
            {pack.name}
          </MenuItem>
        ))}
      </Select>
    </Modal>
  );
});

export default ModalMoveIngestPack;
